import { courseApis } from '@/api/course';
import type { IPayment } from '@/api/types';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import type { ICourseDetails, ICourseInitialState, IThunkAPI } from '../types';

export const initialState: ICourseInitialState = {
  courseList: undefined,
};

// list gigs
export const getCoursesList = createAsyncThunk<ICourseDetails, { gigId: number; applicationId: number }, IThunkAPI>(
  'courses/list',
  async ({ gigId, applicationId }, thunkAPI) => {
    try {
      const response = await courseApis.getCoursesList(gigId, applicationId);

      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const getRescheduleCoursesList = createAsyncThunk<ICourseDetails, number, IThunkAPI>(
  'rescheduleCourses/list',
  async (gigId, thunkAPI) => {
    try {
      const response = await courseApis.getRescheduleCoursesList(gigId);

      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

//make payment
export const makePayment = createAsyncThunk<any, IPayment, IThunkAPI>(
  'courses/makePayment',
  async (payload, thunkAPI) => {
    try {
      const response = await courseApis.makePayment(payload);

      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const courseSlice = createSlice({
  name: 'courseSlice',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getCoursesList.fulfilled, (state, action) => {
      state.courseList = action.payload;
    });
    builder.addCase(getRescheduleCoursesList.fulfilled, (state, action) => {
      state.courseList = action.payload;
    });
  },
});

export default courseSlice.reducer;
